import { useEffect, useRef, useState } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import dayjs from 'dayjs';
import { Button, Popover, Space, Switch, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';

const WebComponent = (props: any) => {
    const title = '会员积分明细';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            setDefaultService(ref.current.defaultService);
            setInitData(() => ref.current.initData);
        }
        //同步获取数据 async - await
        // const fetchData = async () => {
        // }
        // fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'membershipPointsPlans',
            render: (val: any) => val?.planName
        },
        {
            title: '类型',
            dataIndex: 'membershipTransactionType',
            render: (val: any, record: any) =>
                < Tooltip placement="topLeft" title={`商户：${record?.merchantId}；
            商户单类型：${record?.merchantOrderTypeId}；
            商户单号：${record?.merchantOrderId}`} > {
                        val?.name
                    }</Tooltip>
        },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => text?.shopName
        },
        {
            title: '交易日期',
            dataIndex: 'sysDate',
            render: (text: any) => dayjs(text.createdAt).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '积分变动',
            dataIndex: 'pointsChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现积分',
            dataIndex: 'currentPoints'
        },
        {
            title: '兑换金额',
            dataIndex: 'pointsRedeemAmount',
            render: (val: number) => <text style={{ color: 'red' }}>{val !== 0 ? val : ''}</text>
        },
        {
            title: '成功',
            dataIndex: 'isTransactionSuccessful',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '成功日期',
            dataIndex: 'successfulDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '撤销',
            dataIndex: 'isTransactionVoid',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '撤销日期',
            dataIndex: 'transactionVoidDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => (
                ((record.membershipTransactionTypeId === 1 || record.membershipTransactionTypeId === -1) &&
                    record.isTransactionVoid === false && !record.membershipTransactionDetails) ?
                    <Popover
                        title="是否撤销？"
                        trigger="click"
                        content={(<Space>
                            <Button onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button type='primary' onClick={() => {
                                fetchApi.PUT(defaultService,
                                    {
                                        apiId: 'membership',
                                        apiExtend: 'pointsTransactionVoid',
                                        apiData: {
                                            originalMembershipPointsDetailsId: id
                                        }
                                    }).then(res => {
                                        if (res?.success === true) {
                                            AntdNotification('success', '执行积分撤销成功');
                                            InitData();
                                        } else {
                                            AntdNotification('error', res?.message);
                                        }
                                    });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === id}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? id : null);
                        }}
                    >
                        <Button type="dashed" >撤销</Button>
                    </Popover> : null)
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'membershipPointsDetails',
        columns,
        showStates: false,
        // EditComponent,
        serviceId: 'business',
        showEdit: false,
        showAdd: false,
        sendPageData: data
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1500} >
                <WebUniversal props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
